import React, { memo, useCallback } from 'react'

import { TFunction } from 'i18next'

import { useEventCapture } from '@surglogs-app/analytics'
import {
  redirectToExternalUrl,
  getStandaloneLoginRoute,
} from '@surglogs-app/routing'

import { useMfaAbortTimer } from '../hooks/useMfaAbortTimer'

import { MfaAbortTimerText } from './MfaAbortTimerText'

interface MfaAbortTimerProps {
  mode: 'setup' | 'login'
  durationMinutes?: number
  t: TFunction<any>
}

export const MfaAbortTimer = memo(
  ({ mode, durationMinutes, t }: MfaAbortTimerProps) => {
    const { captureEvent } = useEventCapture()

    const onTimeout = useCallback(() => {
      captureEvent('mfa_timeout', { context: 'login', action: mode })
      redirectToExternalUrl(getStandaloneLoginRoute())
    }, [captureEvent, mode])

    const { isLastMinute, timeLeft } = useMfaAbortTimer({
      durationMinutes,
      onTimeout,
    })

    return <MfaAbortTimerText {...{ mode, isLastMinute, timeLeft, t }} />
  },
)
